import React from 'react';
import PropTypes from 'prop-types';

import { formatMoney } from '../../../shared/format';

function PointBalance({ value }) {
	return (
		<div className={`payouts__item ${process.env.CPA_ENV === 'rocket' ? 'payouts__item-wide' : ''}`}>
			<p className="payouts__value payouts__value--points">
				<span className="payouts__value-sign">
					Q
				</span>
				<span className="payouts__value-amount">
					{formatMoney(value, true)}
				</span>
			</p>
		</div>
	);
}

PointBalance.propTypes = {
	value: PropTypes.number.isRequired
};

export default PointBalance;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/sidebar/components/debt-widget/point-balance.js